exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tips[data-v-408ac067]{width:20px;height:20px;margin-bottom:-3px}\n", ""]);

// exports
